export enum ElectricMeterProductKey {
    BY_USAGE = 'BY_USAGE',
    PREPAID = 'PREPAID',
    FLATRATE = 'FLATRATE',
    NO_CHARGE = 'NO_CHARGE',
}

export interface ElectricMeterProductType {
    id: number;
    key: ElectricMeterProductKey;
    settingsKey: string;
    description: string;
}
